/*
 * @LastEditors: PanYunhong
 * @LastEditTime: 2023-05-19 09:55:40
 */
import {
  postRequest,
} from '@/request/request';

// 发送对象组织下拉树
export const selectTreeList = () => postRequest('/company/selectTreeList');
// 组织下人员查询
export const selectUserList = (params:any) => postRequest('/user/selectUserList',params);
// 下发列表查询
export const selectNotice = (params:any) => postRequest('/gaoChunPollute/selectNotice',params);
// 新建下发
export const insertNotice = (params:any) => postRequest('/gaoChunPollute/insertNotice',params);
